import React, { FC } from "react";
import cn from "classnames";
import { CardPrice } from "src/components/Card/CardPrice";
import { Link } from "src/components/Link";
import { getImageUrl } from "src/utils/getImageUrl";
import { ILocation } from "src/@types/users";

interface Props {
  main_photo?: string;
  title: string;
  cost: number;
  location: ILocation;
  href?: string;
  isActiveStatus: boolean;
}

export const DealHead: FC<Props> = ({
  main_photo,
  title,
  cost,
  location,
  href = "",
  isActiveStatus,
}) => (
  <div className="flex flex-col md:flex-row md:h-14 bg-purple-lighter rounded-md">
    {main_photo && (
      <Link className="flex" href={href}>
        <div className="w-full md:w-50 lg:w-80">
          <img
            className="w-full h-full object-cover object-center rounded-20"
            src={getImageUrl(main_photo)}
            alt={title}
          />
        </div>
      </Link>
    )}

    <div className="flex flex-col md:flex-row justify-between self-center gap-y-3 gap-x-20 w-full p-3 md:px-5 md:py-0">
      <Link className="group" href={href}>
        <h4
          title={title}
          className={cn("flex-1 self-center line-clamp-2 md:line-clamp-1", {
            " group-hover:text-purple-base group-hover:underline":
              isActiveStatus,
          })}
        >
          {title}
        </h4>
      </Link>

      <div className="flex justify-between md:justify-start gap-5">
        <CardPrice price={cost}/>

        <div>
          <img
            className="min-w-12.5 min-h-7.5"
            src={getImageUrl(location.country.icon)}
            alt={location.country.name}
          />
        </div>
      </div>
    </div>
  </div>
);
